import { FC } from 'react'
import { PopoverContacts } from '@sequencehq/quote-content'
import { usePopoverRecipients } from './usePopoverRecipients'

export const PopoverRecipients: FC<{ 'data-testid'?: string }> = ({
  'data-testid': dataTestId
}) => {
  const hook = usePopoverRecipients()

  if (!hook.isVisible) return null

  return (
    <PopoverContacts
      width="300px"
      contacts={hook.contacts}
      data-testid={dataTestId}
    />
  )
}
